/**
 * Live build progress: `n / total`, the current file (when the server reports
 * it), and indexed / skipped / failed counts. The parent polls; this renders.
 */

import { Badge, Group, Paper, Progress, Stack, Text } from "@mantine/core";
import type { IndexDetailOut } from "@/shared/api/indexes";
import { deriveBuildProgress } from "./collectionMeta";

export function BuildProgressCard({ detail }: { detail: IndexDetailOut }) {
  const p = deriveBuildProgress(detail);
  const pct = p.total > 0 ? Math.round((p.done / p.total) * 100) : 0;
  return (
    <Paper withBorder radius="md" p="md" data-testid="build-progress">
      <Stack gap="xs">
        <Group justify="space-between">
          <Text fw={600}>{p.queued ? "Queued — waiting for a runner…" : "Building…"}</Text>
          <Text size="sm" aria-label="Build progress count">
            {p.done} / {p.total}
          </Text>
        </Group>
        <Progress value={pct} animated striped aria-label="Build progress" />
        {p.currentFile && (
          <Text size="xs" c="dimmed" truncate>
            Now: {p.currentFile}
          </Text>
        )}
        <Group gap="xs">
          <Badge variant="light" color="green">
            {p.indexed} indexed
          </Badge>
          <Badge variant="light" color="yellow">
            {p.skipped} skipped
          </Badge>
          <Badge variant="light" color="red">
            {p.failed} failed
          </Badge>
          <Badge variant="light" color="gray">
            {p.pending} pending
          </Badge>
        </Group>
      </Stack>
    </Paper>
  );
}
